module.exports = __webpack_public_path__ + "static/media/01-2-meeting-room.cd52d88a.webp";